import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=7cf9ed9b"
import script from "./checkbox.ts?vue&type=script&lang=js&external"
export * from "./checkbox.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf9ed9b')) {
      api.createRecord('7cf9ed9b', component.options)
    } else {
      api.reload('7cf9ed9b', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=7cf9ed9b", function () {
      api.rerender('7cf9ed9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/form/checkbox.vue"
export default component.exports